import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { TChatbotAgent } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

type TParams = {
  friendlyUrl: string
  queryOptions?: Partial<
    UseQueryOptions<HttpServiceBaseResponse<TChatbotAgent>>
  >
}

const useGetAgentByFriendlyUrl = ({ friendlyUrl, queryOptions }: TParams) => {
  return useQuery({
    queryKey: queryKeys.agents({ friendlyUrl }),
    queryFn: () =>
      HttpService.get<TChatbotAgent>(
        {
          path: pathBuilder(EServerPath.guestAgentByFriendlyUrl, {
            friendlyUrl,
          }),
        },
        EHttpService.agent,
      ),
    enabled: !!friendlyUrl,
    retry: false,
    ...queryOptions,
  })
}

export default useGetAgentByFriendlyUrl
